import { Controller } from "@hotwired/stimulus"

// Mobile breakpoint matching TailwindCSS md: (768px)
const MOBILE_BREAKPOINT = 768

export default class extends Controller {
  static targets = ["grid", "table"]

  connect() {
    this._initStorageKey()
    this._setupResizeListener()
    this._applyStoredView()
  }

  disconnect() {
    this._removeResizeListener()
  }

  // Called when grid target is connected/reconnected (e.g., after Turbo Stream update)
  gridTargetConnected() {
    this._applyStoredView()
  }

  // Called when table target is connected/reconnected (e.g., after Turbo Stream update)
  tableTargetConnected() {
    this._applyStoredView()
  }

  _initStorageKey() {
    const body = document.body
    const controller = body.dataset.controllerName
    const action = body.dataset.actionName
    this._autoKey = `${controller}#${action}_view`
  }

  _setupResizeListener() {
    this._resizeHandler = () => {
      // Only switch to grid if on mobile AND not already showing grid
      if (this._isMobileViewport() && this.hasGridTarget && this.gridTarget.classList.contains("hidden")) {
        this.showView("grid")
      }
    }
    window.addEventListener("resize", this._resizeHandler)
  }

  _removeResizeListener() {
    if (this._resizeHandler) {
      window.removeEventListener("resize", this._resizeHandler)
    }
  }

  _isMobileViewport() {
    return window.innerWidth < MOBILE_BREAKPOINT
  }

  _applyStoredView() {
    if (!this.hasGridTarget || !this.hasTableTarget) return

    // Mobile: always show grid, ignore localStorage
    if (this._isMobileViewport()) {
      this.showView("grid")
      return
    }

    const savedView = localStorage.getItem(this._autoKey) || "grid"
    this.showView(savedView)
  }

  showGrid() {
    this.showView("grid")
    // Only save preference on desktop
    if (!this._isMobileViewport()) {
      localStorage.setItem(this._autoKey, "grid")
    }
  }

  showTable() {
    // Block table view on mobile entirely
    if (this._isMobileViewport()) return

    this.showView("table")
    localStorage.setItem(this._autoKey, "table")
  }

  showView(view) {
    if (!this.hasGridTarget || !this.hasTableTarget) return

    if (view === "grid") {
      this.gridTarget.classList.remove("hidden")
      this.tableTarget.classList.add("hidden")
    } else {
      this.gridTarget.classList.add("hidden")
      this.tableTarget.classList.remove("hidden")
    }
  }
}